module.exports = __webpack_public_path__ + "static/results-8ddedec02d843f6ac36b917d4e8a1ef9.gif";